import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

const PADDING_BOTTOM = 230;

export const HeaderContainer = styled.div(({ theme }) => ({
    background: theme.colors[theme.colorMode].background_Primary,
}));

export const ContentContainer = styled.div(() => ({
    paddingBottom: `calc(${PADDING_BOTTOM}px + var(--sab, 0px))`,
}));

export const HeaderTitle = styled(Text)<{ isLoading?: boolean }>(({ theme, isLoading }) => ({
    ...(isLoading && {
        marginBottom: `calc(${theme.spacing.xxSmall} + ${theme.spacing.xxxSmall})`,
    }),
}));
